module.exports = __webpack_public_path__ + "img/Q2.155201f1.jpg";